import React from 'react';

import CustomTooltipDocumentNameCell from '../components/CustomTooltipDocumentNameCell';
import DocumentNameCell from '../components/DocumentNameCell';

export const getListViewCellRenderer = (
  rowData,
  allDisabledIds,
  rowIndicator,
) => {
  const { tooltipProps } = rowData;
  if (tooltipProps) {
    return (
      <CustomTooltipDocumentNameCell
        rowData={rowData}
        disabledIds={allDisabledIds}
        rowIndicator={rowIndicator}
      />
    );
  }
  return (
    <DocumentNameCell
      rowData={rowData}
      disabledIds={allDisabledIds}
      rowIndicator={rowIndicator}
    />
  );
};
